import { post } from './request';

class SelfRegistration {
  static createSelfRegistration(payload) {
    return post('/self-registration/create', payload).then((res) => res.data);
  }
}

export default SelfRegistration;
